import { noop } from '@philips-internal/oswald-ui-utils';
import { BaseFragment } from './base-fragment.js';
class SubmittableFragment extends BaseFragment {
    constructor() {
        super(...arguments);
        this.state = {
            content: null,
            contextData: {},
            loaded: false,
            node: null,
        };
        this.unlistenSubmittableFragmentContext = noop;
    }
    componentWillUnmount() {
        if (this.props.disposable) {
            this.unlistenSubmittableFragmentContext();
        }
        super.componentWillUnmount();
    }
    async provideFragment(engine, options) {
        const { onCancel, onSubmit } = this.props;
        const node = await engine.provideFragment({ ...options, submittable: true });
        const submittableFragmentContext = node.getSubmittableFragmentContext();
        this.unlistenSubmittableFragmentContext();
        const unlistenCancel = submittableFragmentContext?.addCancelListener(onCancel) ?? noop;
        const unlistenSubmit = submittableFragmentContext?.addSubmitListener(onSubmit) ?? noop;
        this.unlistenSubmittableFragmentContext = () => {
            unlistenCancel();
            unlistenSubmit();
        };
        return node;
    }
}
export { SubmittableFragment, };
//# sourceMappingURL=submittable-fragment.js.map